import React from 'react'
import { Formik } from 'formik';
import * as Yup from 'yup';
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import './form.css'

const ContactForm = ({categories}) => {
    const activeCategories =  categories.filter(cat => cat.is_active).sort((g1, g2) => g1.display_order - g2.display_order);

      return (
          <Formik
              initialValues={{  firstName: '', lastName: '',  email: '', phone: '', messageBody: '',  emailDestination: ''  }}
              validationSchema={Yup.object({
                firstName: Yup.string()
                .max(75, 'Must be 75 characters or fewer')
                .required('Please enter your first name'),
                lastName: Yup.string()
                .max(75, 'Must be 75 characters or fewer')
                .required('Please enter your last name'),
                email: Yup.string()
                .email('Invalid email address')
                .required('Please enter your email'),
                phone: Yup.string()
                .max(12, 'Must be 12 characters or fewer')
                .required('Please enter your phone number'),
                messageBody: Yup.string().required('Please enter your message or question'),
                reasonForContact: Yup.string().required('Please select what we can help you with')
              })}
              onSubmit={(values, {resetForm, setSubmitting, setStatus}) => {
                setSubmitting(true)
                let catObj = activeCategories.filter(cat => cat.short_name === values.reasonForContact);
                if(catObj[0].group_to_email === 'CSU'){
                    values.emailDestination = 'jvangeel@lcb.state.nv.us'
                }
                else if(catObj[0].group_to_email === 'Library'){
                    values.emailDestination = 'jvangeel@lcb.state.nv.us'
                }
                else {
                    values.emailDestination = 'jvangeel@lcb.state.nv.us'
                }
                //values.emailDestination= 'jvangeel@lcb.state.nv.us'

                const requestOptions = {
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'omit',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json'}, 
                    body: JSON.stringify(values)
                }

                fetch('/App/API/ContactLcb/Research?apiKey=F829A3F0-9475-4B88-877F-E29C048DC8BA', requestOptions)
                .then(response => {
                    if(response.ok){
                        resetForm()
                        setSubmitting(false);
                        setStatus({
                            sent: true,
                            msg: "Thank you for reaching out. We will get back to you shortly."
                        })
                    }
                    else {
                        setSubmitting(false);
                        setStatus({
                            sent: false,
                            msg: "We couldn't submit your form at this time. Try again later or use one of the other contact methods below to reach us."
                        })
                    }
                })
                .catch(error => {
                    setSubmitting(false);
                    setStatus({
                            sent: false,
                            msg: "We couldn't submit your form at this time. Try again later or use one of the other contact methods below to reach us."
                        })
                    //console.error('Unable to send:', error)
                    }) 
              }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting,
                    status
                }) => (
                <form onSubmit={handleSubmit}>
                    <Form.Row className="mx-lg-5">
                        <Form.Group as={Col} md="6" controlId="firstName">
                            <Form.Label>First Name*</Form.Label>
                            <Form.Control 
                                type="text" 
                                placeholder="Enter first name" 
                                onChange={handleChange} 
                                value={values.firstName} 
                                onBlur={handleBlur}
                                isInvalid={!!errors.firstName}
                                isValid={touched.firstName && !errors.firstName}
                            />
                            <Form.Control.Feedback/>
                            <Form.Control.Feedback type="invalid">
                                {errors.firstName}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="lastName">
                            <Form.Label>Last Name*</Form.Label>
                            <Form.Control 
                                type="text" 
                                placeholder="Enter last name" 
                                onChange={handleChange}  
                                value={values.lastName}
                                onBlur={handleBlur}
                                isInvalid={!!errors.lastName}
                                isValid={touched.lastName && !errors.lastName}
                            />
                            <Form.Control.Feedback/>
                            <Form.Control.Feedback type="invalid">
                                {errors.lastName}
                            </Form.Control.Feedback>
                        </Form.Group>     
                    </Form.Row> 
                    <Form.Row className="mx-lg-5">
                        <Form.Group as={Col} md="6" controlId="email">
                            <Form.Label>Email*</Form.Label>
                            <Form.Control 
                                type="email" 
                                placeholder="Enter email " 
                                onChange={handleChange}  
                                value={values.email}
                                onBlur={handleBlur}
                                isInvalid={!!errors.email}
                                isValid={touched.email && !errors.email}
                            />
                            <Form.Control.Feedback/>
                            <Form.Control.Feedback type="invalid">
                                {errors.email}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="phone">
                            <Form.Label>Phone*</Form.Label>
                            <Form.Control 
                                type="phone" 
                                placeholder="Enter phone " 
                                onChange={handleChange}  
                                value={values.phone}
                                onBlur={handleBlur}
                                isInvalid={!!errors.phone}
                                isValid={touched.phone && !errors.phone}
                            />
                            <Form.Control.Feedback/>
                            <Form.Control.Feedback type="invalid">
                                {errors.phone}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row className="mx-lg-5">
                        <Form.Group controlId="reasonForContact" as={Col} sm="12">
                            <Form.Label>I have a question about...</Form.Label>
                            <Form.Control as="select" 
                            onChange={handleChange} 
                            value={values.reasonForContact}
                            onBlur={handleBlur}
                            isInvalid={!!errors.reasonForContact}
                            isValid={touched.reasonForContact && !errors.reasonForContact}
                            >
                            <option>(choose an item from this list)</option>
                            {activeCategories.map((cat) => {
                                return <option value={cat.short_name} key={cat.short_name}>{cat.long_name}</option>
                            })}
         
                            </Form.Control>
                            <Form.Control.Feedback/>
                            <Form.Control.Feedback type="invalid">
                                {errors.reasonForContact}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row className="mx-lg-5">
                        <Form.Group controlId="messageBody" as={Col} sm="12">
                            <Form.Label>Tell us more about how we can help*</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={6} 
                                onChange={handleChange}  
                                value={values.messageBody} 
                                onBlur={handleBlur}
                                isInvalid={!!errors.messageBody}
                                isValid={touched.messageBody && !errors.messageBody}
                            />
                            <Form.Control.Feedback/>
                            <Form.Control.Feedback type="invalid">
                                {errors.messageBody}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                    {status && status.msg && (
                        <div className={`alert ${ status.sent ? "alert-success" : "alert-danger"} mx-lg-5`}>
                            {status.msg}
                        </div>
                    )}
                    <div className="float-right mr-lg-5"> 
                        <Button variant="primary" type="submit" disabled={isSubmitting}>Submit</Button>
                    </div>
                </form>
                )}
          </Formik>
        
      )
}

export default ContactForm